module.exports = __webpack_public_path__ + "static/img/manual-3.6afaa46.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-3.png
// module id = bLIs
// module chunks = 4